import { Link } from "react-router-dom";
import { Eyebrow } from "@/components/shared";
import ArchitectureDiagram from "@/components/marketing/ArchitectureDiagram";
import { ArrowRight } from "lucide-react";

const steps = [
  ["Create an account", "Sign up in seconds. Verify your email and optionally enable MFA."],
  ["Select storage & region", "Choose how much backup storage you need and where it should live."],
  ["Choose your connection", "Direct TLS or a private WireGuard tunnel — we recommend WireGuard."],
  ["Pick a retention policy", "Standard, Business or Long Term presets — or fully custom."],
  ["Enter payment & deploy", "Secure Stripe checkout, then click Deploy Backup Server."],
  ["We provision everything", "Compute, PBS install, datastore, credentials, firewall, TLS & monitoring — automatically."],
  ["Connect Proxmox", "Paste the supplied values into Proxmox, or run the generated CLI command."],
  ["Backups begin", "We monitor health, storage, verification and security for you — continuously."],
];

export default function HowItWorks() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
      <Eyebrow>How it works</Eyebrow>
      <h1 className="max-w-3xl font-display text-4xl font-extrabold tracking-tight text-slate-50 sm:text-5xl">From signup to protected in minutes.</h1>
      <p className="mt-4 max-w-2xl text-slate-400">Ordering an offsite Proxmox Backup Server should feel like ordering a SaaS subscription. It does.</p>

      <div className="mt-12"><ArchitectureDiagram /></div>

      <div className="mt-12 grid gap-4 sm:grid-cols-2">
        {steps.map(([t, d], i) => (
          <div key={t} className="flex gap-4 rounded-xl border border-slate-800 bg-slate-900/40 p-5">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-cyan-500/30 bg-cyan-500/10 font-mono text-sm font-bold text-cyan-300">{i + 1}</div>
            <div>
              <div className="font-display font-semibold text-slate-100">{t}</div>
              <p className="mt-1 text-sm text-slate-400">{d}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 text-center">
        <Link to="/signup" className="inline-flex items-center gap-2 rounded-lg bg-cyan-400 px-8 py-3.5 font-semibold text-[#06080D] hover:bg-cyan-300">
          Deploy My Backup Server <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
